import { IntegrationType, ObjectType } from 'generated/graphql';

export const mapIntegrationTypeToObjectType = (
  integrationType: IntegrationType,
): ObjectType | undefined => {
  switch (integrationType) {
    case IntegrationType.Feedback:
      return ObjectType.Feedback;
    case IntegrationType.User:
      return ObjectType.User;
    case IntegrationType.Account:
      return ObjectType.Account;
    default:
      return undefined;
  }
};
